import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseEntity } from 'app/model';
import { environment } from 'environments/environment';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { BusyService, mapJsonObjectToClient, mapJsonObjectToServer } from '.';
import { extractData } from '../utils/entity-helper';
import { I6ApiResponse } from '../auth/i6-api-response';

@Injectable({
  providedIn: 'root',
})
export class LegacyService {
  constructor(private httpClient: HttpClient, private busyService: BusyService) {}

  genspAccountTemplateCopy(
    createdBy: string,
    templateId?: number,
    adminId?: number,
    append?: boolean
  ): Observable<boolean> {
    const params = {
      createdBy,
    };
    if (templateId) {
      params['templateId'] = templateId;
    }
    if (adminId) {
      params['adminId'] = adminId;
    }
    if (append) {
      params['append'] = append;
    }
    return this.callApiStoredProcedure('gensp_AccountTemplateCopy', 'Copying account template...', params).pipe(
      map((response) => response.success && response.value === 0)
    );
  }

  webspApplicationSetting(): Observable<{ name?: string; value?: string }[]> {
    return this.callApiStoredProcedure('websp_ApplicationSetting', 'Getting application settings...').pipe(
      map((response) => (response.success ? response.value : []))
    );
  }

  private callApiStoredProcedure(
    storedProcedure: string,
    busyMessage: string,
    params?:
      | HttpParams
      | {
          [param: string]: string | number | boolean | readonly (string | number | boolean)[];
        }
  ): Observable<I6ApiResponse> {
    const options = params ? { params: params } : {};
    return this.busyService.busy$(
      busyMessage,
      this.httpClient
        .get<I6ApiResponse>(`${environment.apiRoot}/Legacy/${storedProcedure}`, options)
        .pipe(map((response) => mapJsonObjectToClient(response)))
    );
  }
}
